/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Templates_Shared_HintInputs */



/**
* | output |
* | --- |
* | "Org-wide templates available to everyone in your organization." |
*
* @param {Presentation_Templates_Shared_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_templates_shared_hint = /** @type {((inputs?: Presentation_Templates_Shared_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Templates_Shared_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisationsweite Vorlagen für alle in Ihrer Organisation.")
	return /** @type {LocalizedString} */ ("Org-wide templates available to everyone in your organization.")
});